import React, { useEffect, useRef } from 'react';
import './Landing.css';

// Reemplazá esta ruta si tu logo está en otro lado.
// Lo más simple: poné el archivo en /public/uploads/logoFarmaSite.jpg
const LOGO_SRC = '/logoFarmaSite.jpg';

const WA_NUMBER = '541123580302';
const PANEL_URL = 'https://farmasite.com.ar/login';
const BUSQUEDA_URL = 'https://farmasite.com.ar/preview';

export default function Landing() {
  const rootRef = useRef(null);

  useEffect(() => {
    // Inyecta las fuentes de Google Fonts (Fraunces + Inter) una sola vez
    if (!document.getElementById('landing-fonts')) {
      const preconnect1 = document.createElement('link');
      preconnect1.rel = 'preconnect';
      preconnect1.href = 'https://fonts.googleapis.com';

      const preconnect2 = document.createElement('link');
      preconnect2.rel = 'preconnect';
      preconnect2.href = 'https://fonts.gstatic.com';
      preconnect2.crossOrigin = '';

      const fontLink = document.createElement('link');
      fontLink.id = 'landing-fonts';
      fontLink.rel = 'stylesheet';
      fontLink.href =
        'https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300..700;1,9..144,300..700&family=Inter:wght@300;400;500;600&display=swap';

      document.head.appendChild(preconnect1);
      document.head.appendChild(preconnect2);
      document.head.appendChild(fontLink);
    }

    const root = rootRef.current;
    if (!root) return;

    // Scroll reveal vía IntersectionObserver (scoped al landing)
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );
    root.querySelectorAll('.reveal').forEach((el) => io.observe(el));

    // Opacidad del navbar al hacer scroll
    const nb = root.querySelector('[data-nb]');
    const onScroll = () => {
      if (!nb) return;
      nb.style.background =
        window.scrollY > 40 ? 'rgba(250,246,236,0.97)' : 'rgba(250,246,236,0.85)';
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      io.disconnect();
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <div className="landing-page" ref={rootRef}>
      {/* ─── NAVBAR ─── */}
      <nav
        data-nb=""
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200, height: 68,
          padding: '0 clamp(20px,4vw,64px)', display: 'flex', alignItems: 'center',
          justifyContent: 'space-between', gap: 24, background: 'rgba(250,246,236,0.85)',
          backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)',
          borderBottom: '1px solid rgba(31,36,32,0.07)', transition: 'background 0.3s',
        }}
      >
        <a href="#hero" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', flexShrink: 0 }}>
          <img
            src={LOGO_SRC}
            alt="FarmaSite"
            className="logo-nav"
            style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, display: 'block' }}
          />
          <span style={{ fontFamily: "'Inter',sans-serif", fontSize: 14, fontWeight: 600, color: '#1F2420', letterSpacing: '-0.01em' }}>FarmaSite</span>
        </a>

        <div className="nb-links" style={{ display: 'flex', gap: 32, alignItems: 'center', flex: 1, justifyContent: 'center' }}>
          <a href="#como-funciona" className="nav-link" style={{ fontFamily: "'Inter',sans-serif", fontSize: 13.5, color: '#1F2420', textDecoration: 'none' }}>Cómo funciona</a>
          <a href="#diferenciales" className="nav-link" style={{ fontFamily: "'Inter',sans-serif", fontSize: 13.5, color: '#1F2420', textDecoration: 'none' }}>Diferenciales</a>
          <a href="#contacto" className="nav-link" style={{ fontFamily: "'Inter',sans-serif", fontSize: 13.5, color: '#1F2420', textDecoration: 'none' }}>Contacto</a>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 20, flexShrink: 0 }}>
          <a href={PANEL_URL} target="_blank" rel="noreferrer" className="nb-panel lnk-q" style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6F6A', textDecoration: 'none', whiteSpace: 'nowrap' }}>Panel de administración</a>
          <a href={BUSQUEDA_URL} target="_blank" rel="noreferrer" className="nb-preview lnk-q" style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6F6A', textDecoration: 'none', whiteSpace: 'nowrap' }}>Ver búsqueda</a>
          <a
            href={`https://wa.me/${WA_NUMBER}?text=Hola%2C%20me%20interesa%20FarmaSite`}
            target="_blank" rel="noreferrer" className="btn-roll"
            style={{ display: 'inline-flex', padding: '10px 20px', background: '#16412F', color: '#FAF6EC', borderRadius: 3, textDecoration: 'none', fontFamily: "'Inter',sans-serif", fontSize: 13, fontWeight: 500, letterSpacing: '0.03em', whiteSpace: 'nowrap', flexShrink: 0 }}
          >
            <span className="roll-top">Hablanos</span>
            <span className="roll-bottom" style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, fontWeight: 500 }}>Hablanos</span>
          </a>
        </div>
      </nav>

      {/* ─── HERO ─── */}
      <section id="hero" className="vh100" style={{ paddingTop: 68, background: '#FAF6EC', position: 'relative', overflow: 'hidden' }}>
        <div className="hero-grid vh100-inner" style={{ display: 'grid', gridTemplateColumns: '55% 45%' }}>
          {/* Text */}
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: 'clamp(40px,5vh,72px) clamp(20px,4vw,64px) clamp(60px,8vh,96px)' }}>
            <div className="ha ha-1" style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 36 }}>
              <div style={{ width: 32, height: 1, background: '#16412F', flexShrink: 0 }} />
              <span style={{ fontFamily: "'Inter',sans-serif", fontSize: 11, fontWeight: 500, color: '#16412F', letterSpacing: '0.14em', textTransform: 'uppercase' }}>Para farmacias</span>
            </div>

            <h1 className="ha ha-2" style={{ fontFamily: "'Fraunces',serif", fontSize: 'clamp(44px,5.5vw,86px)', fontWeight: 600, lineHeight: 0.93, letterSpacing: '-0.03em', color: '#1F2420', marginBottom: 36 }}>
              Tu farmacia,<br />
              tu QR,<br />
              <em style={{ fontStyle: 'italic' }}>más cerca de tus clientes.</em>
            </h1>

            <p className="ha ha-3" style={{ fontFamily: "'Fraunces',serif", fontSize: 'clamp(20px,2vw,28px)', fontWeight: 300, color: '#1F2420', lineHeight: 1.32, maxWidth: 460, marginBottom: 14 }}>Más servicio para todos,<br />menos trámites para vos.</p>

            <p className="ha ha-3" style={{ fontFamily: "'Inter',sans-serif", fontSize: 12.5, color: '#6B6F6A', maxWidth: 400, lineHeight: 1.6, marginBottom: 44 }}>En línea con la normativa vigente de información de precios al consumidor.</p>

            <div className="ha ha-4" style={{ display: 'flex', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
              <a
                href={`https://wa.me/${WA_NUMBER}?text=Hola%2C%20quiero%20mi%20QR%20de%20FarmaSite`}
                target="_blank" rel="noreferrer" className="btn-roll"
                style={{ display: 'inline-flex', padding: '15px 30px', background: '#16412F', color: '#FAF6EC', borderRadius: 3, textDecoration: 'none', fontFamily: "'Inter',sans-serif", fontSize: 14, fontWeight: 500, letterSpacing: '0.04em' }}
              >
                <span className="roll-top">Quiero mi QR</span>
                <span className="roll-bottom" style={{ fontFamily: "'Inter',sans-serif", fontSize: 14, fontWeight: 500 }}>Quiero mi QR</span>
              </a>
              <a href="mailto:contacto@farmasite.com.ar" className="lnk-mail" style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6F6A', textDecoration: 'none', borderBottom: '1px solid rgba(107,111,106,0.35)', paddingBottom: 1 }}>o escribinos por mail →</a>
            </div>
          </div>

          {/* Decoration */}
          <div className="hero-deco" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '60px 40px 60px 0', position: 'relative', overflow: 'hidden' }}>
            <svg viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', width: '110%', height: '110%', opacity: 0.035, pointerEvents: 'none', userSelect: 'none' }}>
              <rect x="12" y="12" width="64" height="64" stroke="#16412F" strokeWidth="8" />
              <rect x="26" y="26" width="36" height="36" fill="#16412F" />
              <rect x="164" y="12" width="64" height="64" stroke="#16412F" strokeWidth="8" />
              <rect x="178" y="26" width="36" height="36" fill="#16412F" />
              <rect x="12" y="164" width="64" height="64" stroke="#16412F" strokeWidth="8" />
              <rect x="26" y="178" width="36" height="36" fill="#16412F" />
              <rect x="88" y="12" width="10" height="10" fill="#16412F" />
              <rect x="104" y="12" width="10" height="10" fill="#16412F" />
              <rect x="120" y="12" width="10" height="10" fill="#16412F" />
              <rect x="136" y="12" width="10" height="10" fill="#16412F" />
              <rect x="152" y="12" width="10" height="10" fill="#16412F" />
              <rect x="88" y="28" width="10" height="10" fill="#16412F" />
              <rect x="120" y="28" width="10" height="10" fill="#16412F" />
              <rect x="152" y="28" width="10" height="10" fill="#16412F" />
              <rect x="104" y="44" width="10" height="10" fill="#16412F" />
              <rect x="136" y="44" width="10" height="10" fill="#16412F" />
              <rect x="88" y="60" width="10" height="10" fill="#16412F" />
              <rect x="120" y="60" width="10" height="10" fill="#16412F" />
              <rect x="148" y="60" width="10" height="10" fill="#16412F" />
              <rect x="12" y="88" width="10" height="10" fill="#16412F" />
              <rect x="28" y="88" width="10" height="10" fill="#16412F" />
              <rect x="44" y="88" width="10" height="10" fill="#16412F" />
              <rect x="60" y="88" width="10" height="10" fill="#16412F" />
              <rect x="88" y="88" width="10" height="10" fill="#16412F" />
              <rect x="104" y="88" width="10" height="10" fill="#16412F" />
              <rect x="120" y="88" width="10" height="10" fill="#16412F" />
              <rect x="12" y="104" width="10" height="10" fill="#16412F" />
              <rect x="44" y="104" width="10" height="10" fill="#16412F" />
              <rect x="88" y="104" width="10" height="10" fill="#16412F" />
              <rect x="120" y="104" width="10" height="10" fill="#16412F" />
              <rect x="164" y="88" width="10" height="10" fill="#16412F" />
              <rect x="180" y="88" width="10" height="10" fill="#16412F" />
              <rect x="196" y="88" width="10" height="10" fill="#16412F" />
              <rect x="212" y="88" width="10" height="10" fill="#16412F" />
              <rect x="164" y="104" width="10" height="10" fill="#16412F" />
              <rect x="196" y="104" width="10" height="10" fill="#16412F" />
              <rect x="180" y="120" width="10" height="10" fill="#16412F" />
              <rect x="212" y="120" width="10" height="10" fill="#16412F" />
              <rect x="164" y="136" width="10" height="10" fill="#16412F" />
              <rect x="196" y="136" width="10" height="10" fill="#16412F" />
              <rect x="180" y="152" width="10" height="10" fill="#16412F" />
              <rect x="212" y="152" width="10" height="10" fill="#16412F" />
              <rect x="88" y="164" width="10" height="10" fill="#16412F" />
              <rect x="104" y="164" width="10" height="10" fill="#16412F" />
              <rect x="120" y="164" width="10" height="10" fill="#16412F" />
              <rect x="136" y="164" width="10" height="10" fill="#16412F" />
              <rect x="88" y="180" width="10" height="10" fill="#16412F" />
              <rect x="120" y="180" width="10" height="10" fill="#16412F" />
              <rect x="104" y="196" width="10" height="10" fill="#16412F" />
              <rect x="136" y="196" width="10" height="10" fill="#16412F" />
              <rect x="152" y="180" width="10" height="10" fill="#16412F" />
              <rect x="164" y="168" width="10" height="10" fill="#16412F" />
              <rect x="196" y="168" width="10" height="10" fill="#16412F" />
              <rect x="180" y="196" width="10" height="10" fill="#16412F" />
              <rect x="212" y="196" width="10" height="10" fill="#16412F" />
              <rect x="28" y="120" width="10" height="10" fill="#16412F" />
              <rect x="60" y="120" width="10" height="10" fill="#16412F" />
              <rect x="12" y="136" width="10" height="10" fill="#16412F" />
              <rect x="44" y="136" width="10" height="10" fill="#16412F" />
              <rect x="60" y="136" width="10" height="10" fill="#16412F" />
              <rect x="28" y="148" width="10" height="10" fill="#16412F" />
              <rect x="44" y="152" width="10" height="10" fill="#16412F" />
            </svg>
            <img
              src={LOGO_SRC}
              alt=""
              className="logo-float logo-deco-hero"
              style={{ width: '62%', maxWidth: 380, opacity: 0.14, borderRadius: '50%', display: 'block', userSelect: 'none', position: 'relative', zIndex: 1, cursor: 'default' }}
            />
          </div>
        </div>

        <div className="ha ha-5" style={{ position: 'absolute', bottom: 28, left: 'clamp(20px,4vw,64px)', display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 22, height: 1, background: '#16412F', opacity: 0.45 }} />
          <span style={{ fontFamily: "'Inter',sans-serif", fontSize: 10.5, color: '#6B6F6A', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Scroll</span>
        </div>
      </section>

      {/* ─── LEGAL STRIP ─── */}
      <div style={{ background: '#FFFFFF', padding: '14px clamp(20px,4vw,64px)', borderTop: '1px solid rgba(31,36,32,0.08)', borderBottom: '1px solid rgba(31,36,32,0.08)' }}>
        <a
          href="https://www.argentina.gob.ar/economia/industria-y-comercio/defensadelconsumidor/escuela-argentina-de-educacion-en-consumo-6"
          target="_blank" rel="noreferrer" className="lnk-q"
          style={{ fontFamily: "'Inter',sans-serif", fontSize: 12, color: '#6B6F6A', textDecoration: 'none' }}
        >
          Resolución vigente de defensa del consumidor →
        </a>
      </div>

      {/* ─── CÓMO FUNCIONA ─── */}
      <section id="como-funciona" style={{ padding: 'clamp(80px,10vh,140px) clamp(20px,4vw,64px)', background: '#FAF6EC' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            <div className="reveal" style={{ width: 24, height: 1, background: '#16412F', flexShrink: 0 }} />
            <p className="reveal rd1" style={{ fontFamily: "'Inter',sans-serif", fontSize: 11, fontWeight: 500, color: '#16412F', letterSpacing: '0.14em', textTransform: 'uppercase' }}>Proceso</p>
          </div>
          <h2 className="reveal rd1" style={{ fontFamily: "'Fraunces',serif", fontSize: 'clamp(34px,4vw,58px)', fontWeight: 300, lineHeight: 1.05, letterSpacing: '-0.02em', color: '#1F2420', marginBottom: 'clamp(48px,7vh,88px)' }}>Cómo funciona</h2>

          <div className="steps-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 1, background: 'rgba(31,36,32,0.1)' }}>
            <div className="step-item reveal rd1" style={{ background: '#FAF6EC', padding: '24px 22px 40px' }}>
              <div className="step-line" />
              <span className="step-num">01</span>
              <h3 style={{ fontFamily: "'Inter',sans-serif", fontSize: 14, fontWeight: 600, color: '#1F2420', marginBottom: 10, lineHeight: 1.35 }}>Personalizá tu página</h3>
              <p style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6F6A', lineHeight: 1.65 }}>Logo, banner, color de marca y fuente de precios, todo desde tu panel sin ayuda técnica.</p>
            </div>

            <div className="step-item reveal rd2" style={{ background: '#FAF6EC', padding: '24px 22px 40px' }}>
              <div className="step-line" />
              <span className="step-num">02</span>
              <h3 style={{ fontFamily: "'Inter',sans-serif", fontSize: 14, fontWeight: 600, color: '#1F2420', marginBottom: 10, lineHeight: 1.35 }}>Imprimí tu QR</h3>
              <p style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6F6A', lineHeight: 1.65 }}>Tu código QR listo para imprimir y exhibir en el local. Cumplís la normativa al instante.</p>
            </div>

            <div className="step-item reveal rd3" style={{ background: '#FAF6EC', padding: '24px 22px 40px' }}>
              <div className="step-line" />
              <span className="step-num">03</span>
              <h3 style={{ fontFamily: "'Inter',sans-serif", fontSize: 14, fontWeight: 600, color: '#1F2420', marginBottom: 10, lineHeight: 1.35 }}>Tu cliente busca y arma su carrito</h3>
              <p style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6F6A', lineHeight: 1.65 }}>Escanea el QR, consulta precios y elige sus productos desde el teléfono.</p>
            </div>

            <div className="step-item reveal rd4" style={{ background: '#FAF6EC', padding: '24px 22px 40px' }}>
              <div className="step-line" />
              <span className="step-num">04</span>
              <h3 style={{ fontFamily: "'Inter',sans-serif", fontSize: 14, fontWeight: 600, color: '#1F2420', marginBottom: 10, lineHeight: 1.35 }}>Te llega el pedido por WhatsApp</h3>
              <p style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6F6A', lineHeight: 1.65 }}>El carrito armado llega directo a tu WhatsApp, listo para preparar.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ─── DIFERENCIALES ─── */}
      <section id="diferenciales" style={{ padding: 'clamp(80px,10vh,140px) clamp(20px,4vw,64px)', background: '#FFFFFF' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            <div className="reveal" style={{ width: 24, height: 1, background: '#16412F', flexShrink: 0 }} />
            <p className="reveal rd1" style={{ fontFamily: "'Inter',sans-serif", fontSize: 11, fontWeight: 500, color: '#16412F', letterSpacing: '0.14em', textTransform: 'uppercase' }}>Por qué FarmaSite</p>
          </div>
          <h2 className="reveal rd1" style={{ fontFamily: "'Fraunces',serif", fontSize: 'clamp(34px,4vw,58px)', fontWeight: 300, lineHeight: 1.05, letterSpacing: '-0.02em', color: '#1F2420', marginBottom: 'clamp(48px,7vh,88px)' }}>Diferenciales</h2>

          <div className="feats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 1, background: 'rgba(31,36,32,0.1)' }}>
            <div className="feat-card reveal rd1" style={{ background: '#FFFFFF', padding: '36px 28px 44px' }}>
              <div style={{ marginBottom: 24 }}>
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" stroke="#16412F" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 8l10-5.5L23 8l-10 5.5z" />
                  <path d="M3 14l10 5.5 10-5.5" />
                  <path d="M3 20l10 5.5 10-5.5" />
                </svg>
              </div>
              <h3 style={{ fontFamily: "'Inter',sans-serif", fontSize: 15, fontWeight: 600, color: '#1F2420', marginBottom: 10, lineHeight: 1.3 }}>Múltiples fuentes de precios</h3>
              <p style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6F6A', lineHeight: 1.65 }}>Conectamos con fuentes oficiales para que los precios estén siempre al día, sin que tengas que hacer nada.</p>
            </div>

            <div className="feat-card reveal rd2" style={{ background: '#FFFFFF', padding: '36px 28px 44px' }}>
              <div style={{ marginBottom: 24 }}>
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" stroke="#16412F" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="6" width="22" height="14" rx="1.5" />
                  <circle cx="9" cy="13" r="2.8" />
                  <path d="M15 10h8M15 13h5M15 16h8" />
                </svg>
              </div>
              <h3 style={{ fontFamily: "'Inter',sans-serif", fontSize: 15, fontWeight: 600, color: '#1F2420', marginBottom: 10, lineHeight: 1.3 }}>Tu marca, siempre</h3>
              <p style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6F6A', lineHeight: 1.65 }}>Logo, colores y banner propios: la búsqueda se ve como parte de tu farmacia, no de otra plataforma.</p>
            </div>

            <div className="feat-card reveal rd3" style={{ background: '#FFFFFF', padding: '36px 28px 44px' }}>
              <div style={{ marginBottom: 24 }}>
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" stroke="#16412F" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M13 2L4 6.5v7.5c0 5 3.7 8.3 9 9.8 5.3-1.5 9-4.8 9-9.8V6.5z" />
                  <path d="M8.5 13.5l3.5 3.5 6.5-7" />
                </svg>
              </div>
              <h3 style={{ fontFamily: "'Inter',sans-serif", fontSize: 15, fontWeight: 600, color: '#1F2420', marginBottom: 10, lineHeight: 1.3 }}>Sin desarrollo ni mantenimiento</h3>
              <p style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6F6A', lineHeight: 1.65 }}>No necesitás un técnico. Vos configurás desde el panel, nosotros nos encargamos del resto.</p>
            </div>

            <div className="feat-card reveal rd4" style={{ background: '#FFFFFF', padding: '36px 28px 44px' }}>
              <div style={{ marginBottom: 24 }}>
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" stroke="#16412F" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 23.5l2.3-6.8A10.5 10.5 0 1 1 9.5 20z" />
                  <path d="M10 12.5c.3 4 6.5 5.5 7.5 2" />
                </svg>
              </div>
              <h3 style={{ fontFamily: "'Inter',sans-serif", fontSize: 15, fontWeight: 600, color: '#1F2420', marginBottom: 10, lineHeight: 1.3 }}>Pedidos directos por WhatsApp</h3>
              <p style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6F6A', lineHeight: 1.65 }}>El cliente arma el carrito y te lo manda directo. Sin formularios, sin plataformas intermedias.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ─── CTA FINAL ─── */}
      <section id="contacto" style={{ background: '#16412F', padding: 'clamp(80px,12vh,160px) clamp(20px,4vw,64px)', textAlign: 'center' }}>
        <div style={{ maxWidth: 680, margin: '0 auto' }}>
          <div className="reveal" style={{ display: 'inline-flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
            <div style={{ width: 20, height: 1, background: 'rgba(250,246,236,0.35)', flexShrink: 0 }} />
            <span style={{ fontFamily: "'Inter',sans-serif", fontSize: 11, fontWeight: 500, color: 'rgba(250,246,236,0.5)', letterSpacing: '0.14em', textTransform: 'uppercase' }}>¿Empezamos?</span>
            <div style={{ width: 20, height: 1, background: 'rgba(250,246,236,0.35)', flexShrink: 0 }} />
          </div>

          <h2 className="reveal rd1" style={{ fontFamily: "'Fraunces',serif", fontSize: 'clamp(40px,5.5vw,76px)', fontWeight: 300, lineHeight: 1.0, letterSpacing: '-0.025em', color: '#FAF6EC', marginBottom: 52 }}>
            Sumá tu farmacia.<br />
            <em style={{ fontStyle: 'italic' }}>Es simple.</em>
          </h2>

          <div className="cta-btns reveal rd2" style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 24 }}>
            <a
              href={`https://wa.me/${WA_NUMBER}?text=Hola%2C%20quiero%20saber%20m%C3%A1s%20sobre%20FarmaSite`}
              target="_blank" rel="noreferrer" className="btn-roll btn-cta-p"
              style={{ display: 'inline-flex', padding: '17px 36px', background: '#FAF6EC', color: '#16412F', borderRadius: 3, textDecoration: 'none', fontFamily: "'Inter',sans-serif", fontSize: 14, fontWeight: 500, letterSpacing: '0.03em', minWidth: 240, justifyContent: 'center' }}
            >
              <span className="roll-top">Escribinos por WhatsApp</span>
              <span className="roll-bottom" style={{ fontFamily: "'Inter',sans-serif", fontSize: 14, fontWeight: 500 }}>Escribinos por WhatsApp</span>
            </a>
            <a
              href="mailto:contacto@farmasite.com.ar" className="btn-roll btn-cta-o"
              style={{ display: 'inline-flex', padding: '17px 36px', background: 'transparent', color: '#FAF6EC', borderRadius: 3, border: '1px solid rgba(250,246,236,0.28)', textDecoration: 'none', fontFamily: "'Inter',sans-serif", fontSize: 14, fontWeight: 400, letterSpacing: '0.03em', minWidth: 220, justifyContent: 'center' }}
            >
              <span className="roll-top">Escribinos por mail</span>
              <span className="roll-bottom" style={{ fontFamily: "'Inter',sans-serif", fontSize: 14 }}>Escribinos por mail</span>
            </a>
          </div>

          <p className="reveal rd3" style={{ fontFamily: "'Inter',sans-serif", fontSize: 12, color: 'rgba(250,246,236,0.35)' }}>Sin contratos de permanencia. Sin sorpresas.</p>
        </div>
      </section>

      {/* ─── FOOTER ─── */}
      <footer style={{ background: '#FAF6EC', padding: '28px clamp(20px,4vw,64px)', borderTop: '1px solid rgba(31,36,32,0.1)' }}>
        <div className="ftr-inner" style={{ maxWidth: 1280, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <img src={LOGO_SRC} alt="FarmaSite" className="logo-nav" style={{ width: 26, height: 26, borderRadius: '50%', objectFit: 'cover', display: 'block', flexShrink: 0 }} />
            <span style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, fontWeight: 600, color: '#1F2420', letterSpacing: '-0.01em' }}>FarmaSite</span>
          </div>
          <p style={{ fontFamily: "'Inter',sans-serif", fontSize: 12, color: '#6B6F6A' }}>© 2025 FarmaSite. Todos los derechos reservados.</p>
          <div style={{ display: 'flex', gap: 20, alignItems: 'center', flexWrap: 'wrap' }}>
            <a href={PANEL_URL} target="_blank" rel="noreferrer" className="lnk-q" style={{ fontFamily: "'Inter',sans-serif", fontSize: 12, color: '#6B6F6A', textDecoration: 'none' }}>Panel</a>
            <a href={BUSQUEDA_URL} target="_blank" rel="noreferrer" className="lnk-q" style={{ fontFamily: "'Inter',sans-serif", fontSize: 12, color: '#6B6F6A', textDecoration: 'none' }}>Ver búsqueda</a>
            <a href="mailto:contacto@farmasite.com.ar" className="lnk-q" style={{ fontFamily: "'Inter',sans-serif", fontSize: 12, color: '#6B6F6A', textDecoration: 'none' }}>contacto@farmasite.com.ar</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
